export const calculatorRoutes = [
  // D-Tech Studios
 {
  path: "/",
  component: "Home",
  title: "D-TechStudios - AI SaaS & Innovation Products | In-House Software Development",
  description: "D-TechStudios builds AI-powered SaaS products entirely in-house. We create intelligent automation tools, streamline workflows, and give you back your time. No outsourcing. Full ownership.",
  keywords: "D-TechStudios, AI SaaS, in-house development, AI automation, software studio, productivity tools, intelligent software, innovation products, custom SaaS, workflow automation"
},
{
  path: "/FounderBio",
  component: "FounderBio",
  title: "Founder Bio - D-TechStudios | AI SaaS Innovation Studio",
  description: "Meet the founder of D-TechStudios. We build AI-powered SaaS products with full in-house ownership, transparency, and user-centric design.",
  keywords: "D-TechStudios founder, AI SaaS founder, software studio founder, in-house development, innovation studio"
},
{
  path: "/Showcase",
  component: "Showcase",
  title: "Product Showcase - D-TechStudios | AI SaaS & Automation Tools",
  description: "Explore D-TechStudios' portfolio of AI SaaS products. Built entirely in-house: AI automation, productivity tools, and intelligent software solutions.",
  keywords: "D-TechStudios showcase, AI SaaS products, automation tools, software portfolio, in-house development, innovation showcase"
},

{
  path: "/AIAutomation",
  component: "AIAutomation",
  title: "AI & Automation Solutions - D-TechStudios | Intelligent SaaS Products",
  description: "D-TechStudios builds AI-powered automation tools that eliminate repetitive tasks, streamline workflows, and save you hours every week. Built entirely in-house with full ownership.",
  keywords: "AI automation, intelligent automation, AI SaaS, workflow automation, repetitive task elimination, D-TechStudios, productivity AI, automation tools"
},

{
  path: "/InHouseDevelopment",
  component: "InHouseDevelopment",
  title: "In-House Development - D-TechStudios | Full Ownership & Quality Control",
  description: "Every D-TechStudios product is conceived, designed, and developed entirely in-house. No outsourcing, no hidden processes — just complete accountability and quality.",
  keywords: "in-house development, software ownership, custom software development, D-TechStudios, quality control, full stack development, SaaS development studio"
},

{
  path: "/TransparencyTrust",
  component: "TransparencyTrust",
  title: "Transparency & Trust - D-TechStudios | Open Software Development",
  description: "D-TechStudios builds products with accountability and openness. Users know exactly who created our software and why. Transparency is our core value.",
  keywords: "transparency in software, trust in tech, open development, accountable software, D-TechStudios, ethical software development, user trust"
},

{
  path: "/UserCentricDesign",
  component: "UserCentricDesign",
  title: "User-Centric Design - D-TechStudios | Simple, Intuitive Software",
  description: "D-TechStudios focuses on real users, designing software that is simple, intuitive, and solves genuine problems. Built entirely in-house with your needs first.",
  keywords: "user-centric design, intuitive software, simple UX, user-first design, D-TechStudios, software usability, human-centered design"
},

//Products
{
  path: "Products/temp-mailhub",
  component: "Products/temp-mailhub",
  title: "Temp-MailHub - Disposable Email Tool by D-TechStudios | Privacy Protection",
  description: "Temp-MailHub by D-TechStudios provides disposable temporary email addresses to protect your real inbox from spam. Free, anonymous, no registration required.",
  keywords: "disposable email, temp mail, temporary email, burner email, throwaway email, temporary inbox, email privacy, D-TechStudios temp mail"
},

{
  path: "Products/quickpdfs",
  component: "Products/quickpdfs",
  title: "QuickPDFs - AI-Powered PDF Processing Tool | D-TechStudios",
  description: "QuickPDFs by D-TechStudios lets you process, edit, convert, and extract data from PDFs instantly using AI automation. No complex software needed.",
  keywords: "PDF tool, AI PDF processing, PDF converter, PDF editor, document automation, QuickPDFs, D-TechStudios, AI document processing"
},

{
  path: "Products/aftertaxpay",
  component: "Products/aftertaxpay",
  title: "AfterTaxPay - Smart Tax & Payment Automation | D-TechStudios",
  description: "AfterTaxPay by D-TechStudios automates tax calculations and payment processing. AI-powered accuracy for freelancers, businesses, and creators.",
  keywords: "tax automation, payment processing, AI tax tool, after tax pay, smart payments, D-TechStudios AfterTaxPay, tax calculation software"
},

{
  path: "Products/font-max",
  component: "Products/font-max",
  title: "FontMax - Premium Font Library & Typography Tools | D-TechStudios",
  description: "FontMax by D-TechStudios offers thousands of premium fonts, font pairing tools, and typography resources for designers. Download and manage fonts effortlessly.",
  keywords: "font library, premium fonts, typography tools, font download, font manager, web fonts, FontMax, D-TechStudios"
},

{
  path: "Products/tools-d-techstudios",
  component: "Products/tools-d-techstudios",
  title: "MathTools - Powerful Equation Solver & Math Calculator | D-TechStudios",
  description: "MathTools by D-TechStudios offers equation solvers, graphing calculators, step-by-step solutions, and math problem-solving tools for students and professionals.",
  keywords: "math tool, equation solver, graphing calculator, algebra calculator, math problem solver, step by step math, MathTools, D-TechStudios"
},

// Legal
{
  path: "Legal/PrivacyPolicy",
  component: "Legal/PrivacyPolicy",
  title: "Privacy Policy - D-TechStudios | AI SaaS & Innovation Products",
  description: "Read D-TechStudios' privacy policy to understand how we collect, use, and protect your data when using our AI SaaS products and innovation tools. Built with transparency.",
  keywords: "privacy policy, D-TechStudios privacy, data protection, AI SaaS privacy, software privacy policy, GDPR compliance, privacy terms"
},

{
  path: "Legal/TermsOfService",
  component: "Legal/TermsOfService",
  title: "Terms of Service - D-TechStudios | AI SaaS Product Usage Terms",
  description: "Review D-TechStudios' terms of service for using our AI SaaS products and innovation tools. Learn about user obligations, intellectual property, and acceptable use.",
  keywords: "terms of service, D-TechStudios terms, SaaS terms, software usage terms, AI product terms, terms and conditions, acceptable use policy"
},

{
  path: "Legal/ContentPolicy",
  component: "Legal/ContentPolicy",
  title: "Content Policy - D-TechStudios | User Content Guidelines",
  description: "D-TechStudios' content policy outlines guidelines for user-generated content across our AI SaaS platforms. Learn about prohibited content and enforcement.",
  keywords: "content policy, user content guidelines, D-TechStudios content, AI content policy, content moderation, acceptable content"
},

{
  path: "Legal/Disclaimer",
  component: "Legal/Disclaimer",
  title: "Disclaimer - D-TechStudios | Legal & Liability Information",
  description: "Read D-TechStudios' legal disclaimer regarding our AI SaaS products, warranties, liability limitations, and professional advice. Important legal information for users.",
  keywords: "disclaimer, legal disclaimer, D-TechStudios disclaimer, liability disclaimer, warranty disclaimer, no warranty, as-is software"
},

{
  path: "Legal/CookiePolicy",
  component: "Legal/CookiePolicy",
  title: "Cookie Policy - D-TechStudios | How We Use Cookies",
  description: "Learn how D-TechStudios uses cookies and similar tracking technologies on our AI SaaS platforms. Understand your choices for cookie consent and management.",
  keywords: "cookie policy, cookies, D-TechStudios cookies, tracking technologies, cookie consent, GDPR cookies, browser cookies"
},

{
  path: "Legal/CopyrightNotice",
  component: "Legal/CopyrightNotice",
  title: "Copyright Notice - D-TechStudios | Intellectual Property Rights",
  description: "View D-TechStudios' copyright notice for our AI SaaS products, website content, software code, and innovation tools. All rights reserved.",
  keywords: "copyright notice, D-TechStudios copyright, intellectual property, software copyright, AI product copyright, all rights reserved, IP rights"
},
];

// Helper function to get route by path
export const getRouteByPath = (path) => {
  return calculatorRoutes.find(route => route.path === path);
};

// Helper function to get all paths
export const getAllPaths = () => {
  return calculatorRoutes.map(route => route.path);
};